module.exports = __webpack_public_path__ + "img/bg-user.78ed2040.jpg";